<template>
  <div class="sellers-list">
    <b-row>
      <b-col cols="6" v-for="(item, index) in regionsCollections" :key="index">
        <b-card>
          <h4>{{ item.text }}</h4>
          <b-table striped hover
            :items="item.sellers"
            :fields="['name', {key: 'pivot.relationship_date', label: $gettext('Start Date')}, {key: 'pivot.relationship_end', label: $gettext('End Date')}, {key: 'actions', label: $gettext('Actions')}]"
            show-empty
            :empty-text="$gettext('There are no sellers to show')"
          >
            <template v-slot:cell(pivot.relationship_date)="item">
              {{moment(item.value).format('L')}}
            </template>
            <template v-slot:cell(pivot.relationship_end)="item">
              {{item.value ? moment(item.value).format('L') : '-'}}
            </template>
            <template v-slot:cell(actions)="row">
              <b-button :disabled="!isHeadSales" variant="secondary" size="sm" v-b-modal.modalAddCommercial @click.prevent="newSeller = {seller: row.item, relationship_date: row.item.pivot.relationship_date.split(' ')[0], relationship_end: row.item.pivot.relationship_end ? row.item.pivot.relationship_end.split(' ')[0] : null, region: row.item.pivot.region_id || null}" style="padding: .5rem .55rem">
                <font-awesome-icon :icon="['fa', 'pencil-alt']" size="2x" style="font-size: 16px;vertical-align: middle" />
              </b-button>
              <b-button :disabled="!isHeadSales" variant="danger" size="sm" @click="deleteSeller(row.item.company_management_user_id)" style="padding: .5rem .65rem">
                <font-awesome-icon :icon="['fa', 'trash-alt']" size="2x" style="font-size: 16px;vertical-align: middle" />
              </b-button>
            </template>
          </b-table>
          <div class="text-right">
            <b-button size="sm" v-b-modal.modalAddCommercial @click.prevent="region = item.value" v-translate>Add New Seller</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-modal size="md" id="modalAddCommercial" ref="modalAddCommercial" hide-footer @hide="resetNewSeller()">
      <div slot="modal-title">
        <span v-if="newSeller.seller && newSeller.seller.company_management_user_id" v-translate>Edit Seller</span>
        <span v-else v-translate>Add New Seller</span>
      </div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <sellers-management-form :newSeller="newSeller" :region="region" :regions="regions" :company="company" @cancel="$refs.modalAddCommercial.hide()" @success="emitSuccess" />
    </b-modal>
  </div>
</template>

<script>
import SellersManagementForm from '@/components/SellersManagementForm'

export default {
  name: 'SellersManagement',
  components: {
    SellersManagementForm
  },
  props: {
    company: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  data() {
    return {
      newSeller: {
        seller: null,
        relationship_date: null,
        relationship_end: null,
        region: null
      },
      regions: [],
      regionsCollections: [],
      region: null
    }
  },
  watch: {
    company(val) {
      this.init()
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.fetchRegions(this.company.country_iso_code)
        .then(response => {
          this.regions = this.regions.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
          this.regionsCollections = [{value: null, text: this.$gettext('All Regions')}].concat([...this.regions])
          this.regionsCollections.forEach((item, i) => {
            this.regionsCollections[i].sellers = this.company.sellers.filter(x => x.pivot.region_id === item.value).sort((a, b) => (a.pivot.relationship_date > b.pivot.relationship_date) ? -1 : ((b.pivot.relationship_date > a.pivot.relationship_date) ? 1 : 0))
          })
        })
    },
    deleteSeller(id) {
      if (
        confirm(this.$gettext('Are you sure you want to DELETE this Seller from this Company?\n\nThis CANNOT be UNDONE.'))
      ) {
        this.$http.delete(this.$appConfig.api.baseUrl + 'companies-management-users/' + id)
          .then(response => {
            this.currentSeller = null
            this.emitSuccess()
          })
      }
    },
    resetNewSeller() {
      this.region = null
      this.newSeller = {
        seller: null,
        relationship_date: null,
        relationship_end: null,
        region: null
      }
    },
    emitSuccess() {
      this.$emit('success', true)
      this.$refs.modalAddCommercial.hide()
    }
  }
}
</script>
